export const common = {
  // Auth
  login: "Đăng nhập",
  register: "Đăng ký", 
  logout: "Đăng xuất",
  email: "Email",
  password: "Mật khẩu",
  confirmPassword: "Xác nhận mật khẩu",
  fullName: "Họ và tên",
  phone: "Số điện thoại",
  rememberMe: "Ghi nhớ đăng nhập",
  forgotPassword: "Quên mật khẩu?",
  noAccount: "Chưa có tài khoản?",
  haveAccount: "Đã có tài khoản?",
  registerNow: "Đăng ký ngay",
  loginNow: "Đăng nhập ngay",
  agreeTerms: "Tôi đồng ý với",
  termsOfUse: "Điều khoản sử dụng",
  privacyPolicy: "Chính sách bảo mật",
  orLoginWith: "Hoặc đăng nhập với",
  
  // Common
  theme: "Giao diện",
  language: "Ngôn ngữ",
  light: "Sáng",
  dark: "Tối",
  vietnamese: "Tiếng Việt",
  english: "Tiếng Anh",
  
  // Navigation
  home: "Trang chủ",
  signals: "Giao dịch",
  education: "Kiến thức",
  plans: "Kế hoạch",
  partners: "Đối tác",
  contact: "Giới thiệu",
  
  // Homepage
  heroTitle: "Nền tảng Trading",
  heroTitleHighlight: "Chuyên nghiệp",
  heroSubtitle: "Tham gia cộng đồng Trader hàng đầu với nhận định chính xác, kế hoạch giao dịch chi tiết và kiến thức hữu ích.",
  getStarted: "Bắt đầu ngay",
  viewSignals: "Xem giao dịch",
  featuresTitle: "Tính năng nổi bật",
  featuresSubtitle: "Công cụ và dịch vụ toàn diện cho trader",
  
  // Features
  tradingSignals: "Tín hiệu 123Trading",
  tradingSignalsDesc: "Nhận tín hiệu giao dịch chính xác từ đội ngũ chuyên gia với tỷ lệ thành công cao",
  tradingPlans: "Kế hoạch 123Trading",
  tradingPlansDesc: "Tạo và quản lý kế hoạch giao dịch chi tiết, tải về hoặc chia sẻ lên nhóm",
  tradingEducation: "Kiến thức 123Trading",
  tradingEducationDesc: "Học hỏi từ các bài viết chuyên sâu về phân tích kỹ thuật và phân tích tâm lí kết hợp diễn biến cơ bản thị trường",
  telegramIntegration: "Thông báo 123Trading",
  telegramIntegrationDesc: "Kết nối với nhóm Telegram để nhận thông báo và chia sẻ tài liệu",
  discordCommunity: "Cộng đồng 123Trading",
  discordCommunityDesc: "Tham gia thảo luận và nhận tín hiệu giao dịch, báo cáo định kỳ qua Discord",
  resultsReport: "Báo cáo 123Trading",
  resultsReportDesc: "Theo dõi tổng kết kết quả tín hiệu hàng tháng với thống kê chi tiết",
  
  // Stats
  statsTitle: "Kết quả tháng gần nhất",
  statsSubtitle: "Thống kê hiệu suất tín hiệu trading",
  successRate: "Tỷ lệ thành công",
  signalsSent: "Tín hiệu đã gửi",
  avgProfit: "Tổng lợi nhuận",
  activeMembers: "Thành viên hoạt động",
  
  // Partners
  partnersTitle: "Đối tác liên kết",
  partnersSubtitle: "Được kết nối với các sàn giao dịch hàng đầu",
  
  // CTA
  ctaTitle: "Sẵn sàng bắt đầu trading?",
  ctaSubtitle: "Tham gia cộng đồng trader chuyên nghiệp ngay hôm nay",
  registerFree: "Đăng ký miễn phí",
  userGuide: "Hướng dẫn tham gia",
  
  // Footer
  footerDescription: "Nền tảng trading chuyên nghiệp với tín hiệu chính xác và cộng đồng trader mạnh mẽ.",
  services: "Dịch vụ",
  support: "Hỗ trợ",
  contactInfo: "Liên hệ",
  
  // Messages
  passwordMismatch: "Mật khẩu xác nhận không khớp!",
  loginToAccount: "Truy cập vào tài khoản của bạn",
  createNewAccount: "Tham gia cộng đồng trader chuyên nghiệp - Nhận tín hiệu miễn phí ngay hôm nay",
  
  // Placeholders
  enterEmail: "Ví dụ: email@domain.com",
  enterPassword: "Nhập mật khẩu (tối thiểu 8 ký tự)",
  enterFullName: "Ví dụ: Nguyễn Văn A",
  enterPhone: "Ví dụ: 0912345678",
  reenterPassword: "Nhập lại mật khẩu để xác nhận",
  
  // Trading History Page (formerly Signals Page)
  signalsPageTitle: "Lịch sử giao dịch",
  signalsPageSubtitle: "Theo dõi và phân tích các giao dịch đã thực hiện",
  todaySignals: "Giao dịch hôm nay",
  monthlyProfit: "Lợi nhuận tháng",
  monthlySignals: "Giao dịch tháng này",
  timeframe: "Khung thời gian",
  status: "Trạng thái",
  all: "Tất cả",
  active: "Đang chạy",
  profit: "Lời",
  loss: "Lỗ",
  refresh: "Làm mới",
  
  // Education Page
  educationPageTitle: "Kiến thức Trading",
  educationPageSubtitle: "Nâng cao kỹ năng trading với các bài viết sâu sắc",
  technical: "Phân tích kỹ thuật",
  educationStrategy: "Chiến lược",   // renamed to avoid duplicate
  risk: "Quản lý rủi ro",
  psychology: "Tâm lý học",
  news: "Tin tức",
  readMore: "Đọc thêm",
  newsletterTitle: "Đăng ký nhận bản tin",
  newsletterSubtitle: "Nhận những bài viết mới nhất và phân tích thị trường hàng tuần",
  subscribe: "Đăng ký",
  
  // Plans Page
  plansPageTitle: "Tạo kế hoạch giao dịch",
  plansPageSubtitle: "Lập kế hoạch chi tiết cho giao dịch của bạn",
  planInfo: "Thông tin kế hoạch",
  planName: "Tên kế hoạch",
  symbol: "Cặp tiền",
  entryPrice: "Giá vào lệnh",
  stopLoss: "Stop Loss",
  takeProfit: "Take Profit",
  riskReward: "Tỷ lệ Risk/Reward",
  strategy: "Chiến lược",   // kept here (unique now)
  notes: "Ghi chú",
  riskLevel: "Mức độ rủi ro",
  createPlan: "Tạo kế hoạch",
  downloadPlan: "Tải về máy",
  shareToTelegram: "Chia sẻ Telegram",
  
  // Partners Page
  partnersPageTitle: "Đối tác liên kết",
  partnersPageSubtitle: "Hợp tác với các nền tảng trading hàng đầu thế giới",
  benefits: "Lợi ích khi đăng ký qua 123Trading",
  reducedFees: "Giảm phí giao dịch",
  reducedFeesDesc: "Nhận ưu đãi phí giao dịch tốt nhất khi đăng ký qua link của chúng tôi",
  signupBonus: "Bonus đăng ký",
  signupBonusDesc: "Nhận bonus và quà tặng đặc biệt khi tạo tài khoản mới",
  support247: "Hỗ trợ 24/7",
  support247Desc: "Được hỗ trợ trực tiếp từ đội ngũ 123Trading khi gặp vấn đề",
  exchanges: "Sàn giao dịch",
  tools: "Công cụ",
  data: "Dữ liệu",
  // registerNow key removed from this section to tránh trùng lặp
  
  // Contact Page
  contactPageTitle: "Liên hệ với chúng tôi",
  contactPageSubtitle: "Chúng tôi luôn sẵn sàng hỗ trợ bạn",
  sendMessage: "Gửi tin nhắn",
  name: "Họ và tên",
  subject: "Chủ đề",
  message: "Nội dung tin nhắn",
  contactMethod: "Phương thức liên hệ ưu tiên",
  sendMessageBtn: "Gửi tin nhắn",
  contactInfoLabel: "Thông tin",   // renamed to avoid duplicate
  supportHours: "Giờ hỗ trợ",
  quickFaq: "FAQ nhanh"
};

export default common;